export default "__VITE_ASSET__CoY3FSSu__"